     const alphabetList = $('#alphabetList');
    const itemWidth = alphabetList.find('li:first-child').outerWidth(true);
    const containerWidth = alphabetList.innerWidth();
    const maxScroll = alphabetList.prop('scrollWidth') - containerWidth;
    let currentPosition = 0;
    
    $('.Scrolling-prevArrow').click(function() {
      currentPosition = 0; // Scroll to the beginning
      alphabetList.animate({ scrollLeft: currentPosition }, 900); 
    });
    
    $('.Scrolling-nextArrow').click(function() {
      // Scroll to the end
      currentPosition = maxScroll;
      alphabetList.animate({ scrollLeft: currentPosition }, 900);
    });
